// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.CrossFilterSetting.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * @module CrossFilterSetting popup component
 */

import React, { PropTypes, Component } from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import { flow, getOr, filter, isEmpty, map, includes, toLower, concat, sortBy, chunk } from 'lodash/fp';

import Popup from 'share/components/controls/CommonPopup/Izenda.Popup';
import Input from 'share/components/controls/Izenda.Input';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import CrossFilterSettingAction from './Izenda.CrossFilterSettingAction';
import ScrollBox from 'share/components/controls/Izenda.ScrollBox';
import OverflowText from 'share/components/controls/Izenda.OverflowText';

@connect(CrossFilterSettingAction)
class CrossFilterSetting extends Component {
  constructor() {
    super();
  }

  static propTypes = {
    store: PropTypes.object
  };

  renderSelectAll = () => {
    const { localization, isIndeterminate, isSelectAll, onSelectAll } = this.props;
    const checkBoxLabel = localization.getText('COMMON_LABEL_ALL');

    return (
      <GridLayout.Col className="checkbox u_noMarginTop" cols={4} key="chk-allIndex">
        <label>
          <Input indeterminate={isIndeterminate} type="checkbox" checked={isSelectAll} onChange={onSelectAll} />
          <OverflowText tooltip={checkBoxLabel}>{checkBoxLabel}</OverflowText>
        </label>
      </GridLayout.Col>
    );
  };

  renderContainer = () => {
    const { selectedReportParts, onSelectReportParts, store } = this.props;

    let data = flow(
      getOr([], 'reportBody.activeReportParts'),
      filter(reportPart => !isEmpty(reportPart.headerTitle)),
      map((reportPart: any) => {
        return {
          value: reportPart.id,
          label: getOr('', 'headerTitle', reportPart),
          checked: includes(reportPart.id, selectedReportParts),
          sortLabel: toLower(getOr('', 'headerTitle', reportPart))
        };
      }),
      sortBy(['sortLabel'])
    )(store);

    let reportPartOptions = data.map((item: Object, index: Number) => {
      return (
        <GridLayout.Col className="checkbox u_noMarginTop" cols={4} key={'chk-' + index}>
          <label>
            <Input
              type="checkbox"
              value={item.value}
              checked={item.checked}
              onChange={onSelectReportParts.bind(this, item)}
            />
            <OverflowText tooltip={item.label}>{item.label}</OverflowText>
          </label>
        </GridLayout.Col>
      );
    });

    let options = concat(this.renderSelectAll(), reportPartOptions);

    let chunkOptions = chunk(3, options);
    return (
      <div>
        {chunkOptions.map(function(item: Object, index: Number) {
          return (
            <GridLayout.Row key={index} className="u_noMarginAll">
              {item}
            </GridLayout.Row>
          );
        })}
      </div>
    );
  };

  render() {
    const { localization, onClosing } = this.props;
    return (
      <Popup visible onClosing={onClosing} autoClose={false} type="none">
        <Popup.Header title={localization.getText('DASHBOARD_LABEL_REPORT_PART_SELECTION')} />
        <Popup.Body>
          <div className="izenda-OperatorValueCheckBoxPopup">
            <ScrollBox>
              <GridLayout>{this.renderContainer()}</GridLayout>
            </ScrollBox>
          </div>
        </Popup.Body>
        <Popup.Footer>
          <Popup.ConfirmationButton type="accept">{localization.getText('COMMON_LABEL_OK')}</Popup.ConfirmationButton>
          <Popup.ConfirmationButton type="cancel">
            {localization.getText('COMMON_LABEL_CANCEL')}
          </Popup.ConfirmationButton>
        </Popup.Footer>
      </Popup>
    );
  }
}

export default CrossFilterSetting;



// WEBPACK FOOTER //
// ./ui/modules/CrossFiltering/Izenda.CrossFilterSetting.js